import * as React from 'react'
import classnames from 'classnames'
import {DMColors, SpriteName} from '../types'

export interface Props {
  name: SpriteName
  color?: DMColors
  displayClasses?: string
}

const SvgSprite: React.FunctionComponent<Props> = ({
  name,
  displayClasses,
  color
}) => {
  const cls = classnames('dm-icon', displayClasses, {
    [`u-${color}`]: color
  })
  return (
    <svg className={cls}>
      <use xlinkHref={`#${name}`} />
    </svg>
  )
}

export default SvgSprite
